import { defineStore } from "pinia";

export interface AlertBannerInfo {
  showAlertBanner: boolean;
  headerText: string;
  informationText: string;
}

export const useAlertStore = defineStore("alert", {
  state: () => ({
    alertBannerInfos: [] as AlertBannerInfo[]
  }),

  getters: {
    getVisibleAlerts: (state) => {
      return state.alertBannerInfos.filter(x => x.showAlertBanner);
    }
  },

  actions: {
    setAlerts(alerts: AlertBannerInfo[]) {
      this.alertBannerInfos = alerts;
    },

    addAlert(alert: AlertBannerInfo) {
      this.alertBannerInfos.push(alert);
    },

    clearAlerts() {
      this.alertBannerInfos = [];
    }
  }
});